import metaDetails from './metaDetails';
import contactModule from './contactModule';
import pageHeaderMediaQuery from './pageHeaderMedia';
import locationQuery from './locationQuery';

export default `
    ... on Location {
        slug
        title
        locationHeader {
            videoType
            headerTitle
            ${pageHeaderMediaQuery}
        }
        ${locationQuery}
        locationCarousel{
            ... on LocationCarouselContentFields {
                carouselTitle {
                    content
                }
                item {
                    asset {
                        url
                        title
                        extension
                    }
                    caption {
                        content
                    }
                }
                backgroundColor {
                    hex
                }
                elementsColor
            }
        }
        locationNearby3Up {
            ... on LocationNearby3UpNearby3Up {
                nearbyTitle {
                    content
                }
                nearbyDescription
                nearbyFeatures {
                    topic
                    featureName
                    mapUrl
                    image {
                        mimeType
                        url
                    }
                }
            }
        }
        ${metaDetails}
        ${contactModule}
    }
`;
